import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchStaffBusinessOverviewDayArgs,
  FetchStaffBusinessOverviewTrainersArgs,
  FetchTrainerDisconnectedClientsArgs,
} from '../api/types/staffBusinessOverview.types';

import {
  fetchStaffBusinessOverviewDay,
  fetchStaffBusinessOverviewTrainers,
  fetchTrainerDisconnectedClients,
} from '../api/staffBusinessOverview.api';

export const staffBusinessOverviewQueryKeys = createQueryKeys(
  'staffBusinessOverview',
  {
    fetchDay: (args: FetchStaffBusinessOverviewDayArgs) => ({
      queryFn: () => fetchStaffBusinessOverviewDay(args),
      queryKey: [args.organizationId, args],
    }),
    fetchTrainers: (args: FetchStaffBusinessOverviewTrainersArgs) => ({
      queryFn: () => fetchStaffBusinessOverviewTrainers(args),
      queryKey: [args.organizationId, args],
    }),
    fetchDisconnectedClients: (args: FetchTrainerDisconnectedClientsArgs) => ({
      queryFn: () => fetchTrainerDisconnectedClients(args),
      queryKey: [args.organizationId, args.trainerId],
    }),
  },
);
